export function formatStringDate(datestr: string | null) {
    if (!datestr) return null

    const date = new Date(datestr)

    return date.toLocaleDateString('ru-RU', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    })
}
